import React from 'react';
import { Clock, Users, Blend } from 'lucide-react';
import './FlexibleLearning.css';

const learningPaths = [
  {
    icon: Clock,
    title: 'Learn Anytime',
    description: 'Self-paced courses that fit your schedule and lifestyle.',
    features: ['24/7 Access', 'Your Own Pace', 'Flexible Deadlines'],
  },
  {
    icon: Users,
    title: 'Learn Together',
    description: 'Live sessions with real-time interaction and community.',
    features: ['Live Mentorship', 'Peer Collaboration', 'Q&A Sessions'],
  },
  {
    icon: Blend,
    title: 'Learn Blended',
    description: 'The best of both worlds—structure with flexibility.',
    features: ['Hybrid Approach', 'Personalized Path', 'Maximum Growth'],
  },
];

export function FlexibleLearning() {
  return (
    <section className="flexible-learning section">
      <div className="flexible-header">
        <h2 className="section-title">Learn Your Way</h2>
        <p className="section-subtitle">
          Choose the learning style that matches your goals and rhythm.
        </p>
      </div>

      <div className="learning-cards">
        {learningPaths.map((path, index) => {
          const Icon = path.icon;
          return (
            <div key={index} className="learning-card">
              <div className="learning-card-inner">
                <div className="learning-icon-wrapper">
                  <Icon size={36} />
                </div>
                <h3 className="learning-title">{path.title}</h3>
                <p className="learning-description">{path.description}</p>
                <ul className="learning-features">
                  {path.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
